import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import axios, { Axios } from 'axios';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  navChange: EventEmitter<any> = new EventEmitter();
  public formRefreshAnnouncedSource: BehaviorSubject<any> =
    new BehaviorSubject<any>('');
  public formRefreshAnnouncedSource1: BehaviorSubject<any> =
    new BehaviorSubject<any>('');
  public attributesList: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public brandList: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public dropdownValue: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public userData: BehaviorSubject<any> = new BehaviorSubject<any>('');

  
  constructor() {}

  publishFormRefresh(value) {
    this.formRefreshAnnouncedSource.next(value);
  }
  parentToChild(value) {
    this.formRefreshAnnouncedSource1.next(value);
  }
  sendBrandList(values) {
    this.brandList.next(values);
  }
  sendAttributesList(value) {
    this.attributesList.next(value);
  }

  getLocationDropdown() {
    axios
      .get(environment.url + 'locations/', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('Token'),
        },
      })
      .then((response) => {
        this.dropdownValue.next(response.data.data.locations);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  getUserDetails() {
    axios
      .get(environment.url + 'auth/user-detail/', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('Token'),
        },
      })
      .then((response) => {
        // console.log(response);
        this.userData.next(response?.data?.data?.user);
      });
  }
}
